module.exports = __webpack_public_path__ + "img/Carousel-Military-Readiness.2637e055.jpeg";